import * as React from 'react'
import { merge } from 'lodash'
const moment = require('moment')

interface PickerProps {
  container?: string
  onChange?: Function
  name?: string
  id?: string
}

export default class MdDate extends React.Component<any, undefined> {

  constructor(props: any) {
    super(props)
  }

  public componentDidMount() {
    const propOptions = {
      container: this.props.options || false
    }

    const options = merge({}, this.props, {
      close: false,
      onSet: (event) => {
        if (event.select) {
          let date = moment(event.select).format()
          if (this.props.isEndDate) {
            date = moment(event.select).endOf('day').toDate()
          }
          this.props.onChange(date)
        }

        if (event.clear === null) {
          this.props.onChange('')
        }
      }
    })

    $(`#${this.props.id}`).pickadate(options)
  }

  public render() {
    return (
      <div style={this.props.style}>
        <input id={this.props.id} style={this.props.inputStyle} placeholder={this.props.name} type='text' className='datepicker'/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./react/components/widgets/MdDate.tsx